module.exports = __webpack_public_path__ + "img/6_125.6a4c9cfe.png";